import { useEffect, useState } from "react";
import { Mic } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Crest, FlagStrip } from "@/components/Brand";

// Public talk link (used by the native apps, which open it directly).
export const VOICE_AGENT_URL = "https://elevenlabs.io/app/talk-to?agent_id=agent_7401m5dbwc8df3t93s5jpxnqec4s&branch_id=agtbrch_8101m5dbwf0temc833y2qjp1tm4d";
const AGENT_ID = "agent_7401m5dbwc8df3t93s5jpxnqec4s";
const WIDGET_SRC = "https://unpkg.com/@elevenlabs/convai-widget-embed";

function useConvaiScript(active) {
  useEffect(() => {
    if (!active || document.querySelector(`script[src="${WIDGET_SRC}"]`)) return;
    const s = document.createElement("script");
    s.src = WIDGET_SRC;
    s.async = true;
    s.type = "text/javascript";
    document.body.appendChild(s);
  }, [active]);
}

export function VoiceButton({ className = "", variant = "default", size = "default", label = "Book by voice" }) {
  const [open, setOpen] = useState(false);
  useConvaiScript(open);

  return (
    <>
      <Button type="button" variant={variant} size={size} onClick={() => setOpen(true)} className={className} data-testid="voice-agent-button">
        <Mic className="h-4 w-4" />
        {label}
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md gap-0 overflow-hidden p-0" data-testid="voice-agent-modal">
          <div style={{ background: "#182678" }}>
            <div className="flex items-center gap-3 px-6 pb-4 pt-6">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-white ring-1 ring-white/30">
                <Crest className="h-10 w-10" />
              </span>
              <div className="leading-tight text-white">
                <div className="font-display text-lg font-extrabold tracking-tight">GPRTU · Travel Ghana</div>
                <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-sky-200">Voice Booking Assistant</div>
              </div>
            </div>
            <FlagStrip className="h-1.5" />
          </div>

          <div className="px-6 py-6">
            <p className="mb-5 text-sm leading-relaxed text-slate-600" data-testid="voice-agent-hint">
              Tap the mic and just say <span className="font-semibold text-slate-900">“I want to book a ticket.”</span> Your assistant will find the route, times and seats for you — in your own words.
            </p>
            <div className="grid min-h-[260px] place-items-center rounded-2xl border border-slate-200 bg-slate-50 p-4" data-testid="voice-agent-widget">
              <elevenlabs-convai agent-id={AGENT_ID} variant="expanded"></elevenlabs-convai>
            </div>
          </div>

          <div className="border-t border-slate-100 py-3 text-center text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">
            Official GPRTU platform · Developed by Nacasky Co. Ltd
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
